export const CHART_TILE_MOCK_DATA = [
  {
    name: "Group 1",
    kind: null,
    value: 100,
    unit: null,
  },
  {
    name: "Group 2",
    kind: null,
    value: 200,
    unit: null,
  },
  {
    name: "Group 3",
    kind: null,
    value: 300,
    unit: null,
  },
  {
    name: "Group 4",
    kind: null,
    value: 400,
    unit: null,
  },
  {
    name: "Group 5",
    kind: null,
    value: 500,
    unit: null,
  },
  {
    name: "Group 6",
    kind: null,
    value: 600,
    unit: null,
  },
  {
    name: "Group 7",
    kind: null,
    value: 700,
    unit: null,
  },
  {
    name: "Group 8",
    kind: null,
    value: 800,
    unit: null,
  },
]
